<template>
  <div>
    <slot name="type" v-bind:type="type"><h1 class="text-primary">{{ type }}</h1></slot>
    <slot name="titre" v-bind:titre="titre"><h1 class="text-secondary">{{ titre }}</h1></slot>
    <slot name="contenu" :contenu="instructions">
      <div id="instructions">
        <hr>
        <div v-html="instructions"></div>
      </div>
    </slot>
    <slot name="contenu_cache" :contenu_cache="contenu_cache" v-if="contenu_cache"></slot>
    <div id="documents" v-if="document">
      <hr>
      <div v-html="document"></div>
    </div>
  </div>
</template>

<script>
import {Exercice} from "@/js/caller";
import {getType, formatType} from "@/js/utils";


export default {
  name : "exerciceView",
  props: {exercice: [Number, Object]},
  data() {
    return {
      show         : true,
      type         : "",
      titre        : "",
      instructions : "",
      contenu_cache: "",
      document     : "",
      textID       : null
    }
  },
  methods: {
    getDataFromWindow() {
      const {
              exercice, level, title, instructions, document
            } = (window.__ExerciceData__ || {});
      return {
        id     : exercice,
        type   : this.getType(level),
        titre  : title,
        contenu: instructions,
        document
      }
    },
    getData(data) {
      const {type, titre, contenu, contenu_cache, document} = data
      this.type = formatType(type);
      this.titre = titre;
      this.instructions = contenu;
      this.contenu_cache = contenu_cache;
      this.document = document;
    },
    getType,
  },
  async created() {
    const {exercice} = this;
    if (!exercice) return;
    if (typeof exercice === "object") return this.getData(exercice);
    Exercice.Get(exercice).then((res) => {
      const {
              type,
              titre,
              contenu,
              contenu_cache,
              document,
            } = (res.id ? res : this.getDataFromWindow());

      this.type = formatType(type);
      this.titre = titre;
      this.instructions = contenu;
      this.contenu_cache = contenu_cache
      this.document = window.__ExerciceData__?.document || document;
      this.$emit("load", res);
    });
  }
}
</script>

<style scoped>

</style>